<template>
  <header class="header">
    <div class="header-inner container">
      <div class="logo">
        <h1>
          <a href="/" title="YasNah application home">+YAS/NAH-</a>
        </h1>
        <small v-if="email"
          >as <strong>{{ email }}</strong></small
        >
      </div>
      <div></div>
      <div class="actions">
        <a :href="websiteUrl" target="_blank" title="Open YasNah website">
          <svg style="width:16px;height:16px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
            />
          </svg>
        </a>
        <div v-if="isAuthenticated">
          <ab-button color="primary" variant="text" @click="logout">Sign Out</ab-button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import Button from './common/Button';

export default {
  components: {
    'ab-button': Button
  },
  computed: {
    ...mapState({
      isAuthenticated: s => s.identity.isAuthenticated,
      email: s => s.identity.email
    }),
    websiteUrl() {
      return location.origin.endsWith(`yasnah.com`) ? location.origin.replace('app.', '') : `https://yasnah.com`;
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('identity/logout');
      window.location.href = '/';
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  .header-inner {
    display: grid;
    align-items: center;
    justify-content: center;
    height: auto;
    grid-template-columns: 250px 1fr max-content;
    max-width: 1140px;
    min-height: 5rem;
    margin: auto;
  }

  .logo {
    position: relative;
    h1 {
      margin: 0;
      padding: 0;
      a {
        color: var(--theme-primary);
        text-transform: uppercase;
        font-size: 26px;
      }
    }
    small {
      position: absolute;
      font-size: 0.75rem;
      font-style: italic;

      transform: translate(2rem, -50%);

      strong {
        font-weight: 700;
        font-style: initial;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    a {
      display: inline-flex;
    }

    > * {
      &:not(:last-child) {
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
